var _mask, _path, _ellipse, _ellipse2, _ellipse3, _ellipse4, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediaEntertaiment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_44981_9414",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.818 26.8192C36.818 22.167 33.0466 18.3956 28.3944 18.3956H11.6052C6.953 18.3956 3.18164 22.167 3.18164 26.8192V27.6088C3.18164 31.8249 6.59948 35.2428 10.8156 35.2428H14.4186C15.4474 35.2428 16.3675 34.6022 16.7245 33.6374C17.0816 32.6725 18.0017 32.032 19.0305 32.032H20.9686C21.9975 32.032 22.9175 32.6725 23.2746 33.6374C23.6316 34.6022 24.5517 35.2428 25.5805 35.2428H29.1837C33.4 35.2428 36.818 31.8248 36.818 27.6085V26.8192Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6052 20.2138H28.3944V16.5774H11.6052V20.2138ZM4.99982 27.6088V26.8192H1.36346V27.6088H4.99982ZM14.4186 33.4246H10.8156V37.061H14.4186V33.4246ZM19.0305 33.8502H20.9686V30.2138H19.0305V33.8502ZM29.1837 33.4246H25.5805V37.061H29.1837V33.4246ZM34.9998 26.8192V27.6085H38.6362V26.8192H34.9998ZM29.1837 37.061C34.4042 37.061 38.6362 32.8289 38.6362 27.6085H34.9998C34.9998 30.8206 32.3959 33.4246 29.1837 33.4246V37.061ZM21.5694 34.2684C22.1905 35.9468 23.7909 37.061 25.5805 37.061V33.4246C25.3125 33.4246 25.0728 33.2577 24.9797 33.0063L21.5694 34.2684ZM20.9686 33.8502C21.2367 33.8502 21.4764 34.017 21.5694 34.2684L24.9797 33.0063C24.3586 31.328 22.7582 30.2138 20.9686 30.2138V33.8502ZM18.4297 34.2684C18.5227 34.017 18.7624 33.8502 19.0305 33.8502V30.2138C17.2409 30.2138 15.6405 31.328 15.0194 33.0063L18.4297 34.2684ZM14.4186 37.061C16.2082 37.061 17.8086 35.9468 18.4297 34.2684L15.0194 33.0063C14.9264 33.2577 14.6867 33.4246 14.4186 33.4246V37.061ZM1.36346 27.6088C1.36346 32.8291 5.59533 37.061 10.8156 37.061V33.4246C7.60364 33.4246 4.99982 30.8208 4.99982 27.6088H1.36346ZM28.3944 20.2138C32.0425 20.2138 34.9998 23.1711 34.9998 26.8192H38.6362C38.6362 21.1628 34.0508 16.5774 28.3944 16.5774V20.2138ZM11.6052 16.5774C5.94885 16.5774 1.36346 21.1628 1.36346 26.8192H4.99982C4.99982 23.1711 7.95716 20.2138 11.6052 20.2138V16.5774Z",
    fill: "#2E2E2E",
    mask: "url(#path-1-inside-1_44981_9414)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.909091,
    cy: 0.909075,
    rx: 0.909091,
    ry: 0.909075,
    transform: "matrix(-1 0 0 1 29.5454 28.395)",
    fill: "currentColor"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.909091,
    cy: 0.909075,
    rx: 0.909091,
    ry: 0.909075,
    transform: "matrix(-1 0 0 1 29.5454 22.9404)",
    fill: "currentColor"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.909076,
    cy: 0.90909,
    rx: 0.909076,
    ry: 0.90909,
    transform: "matrix(4.37121e-08 1 1 -4.37106e-08 30.4541 25.6677)",
    fill: "currentColor"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 0.909076,
    cy: 0.90909,
    rx: 0.909076,
    ry: 0.90909,
    transform: "matrix(4.37121e-08 1 1 -4.37106e-08 25.0005 25.6677)",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3638 23.85V29.3044",
    stroke: "#2E2E2E",
    strokeWidth: 1.81818,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63623 26.5772L14.0908 26.5772",
    stroke: "#2E2E2E",
    strokeWidth: 1.81818,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4541 19.3038L20.4541 12.0312C20.4541 8.01467 23.7102 4.75859 27.7267 4.75857L29.545 4.75856",
    stroke: "#2E2E2E",
    strokeWidth: 1.81818
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaEntertaiment);
export default __webpack_public_path__ + "static/media/Media & Entertaiment.c06489964c8886f07f02e274ca2f8657.svg";
export { ForwardRef as ReactComponent };